
import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import AppearanceSettings from "@/components/admin/settings/AppearanceSettings";
import GeneralSettings from "@/components/admin/settings/GeneralSettings";
import ProductSettings from "@/components/admin/settings/ProductSettings";
import NotificationSettings from "@/components/admin/settings/NotificationSettings";
import SystemSettings from "@/components/admin/settings/SystemSettings";
import BrandingSettings from "@/components/admin/settings/BrandingSettings";
import SEOSettings from "@/components/admin/settings/SEOSettings";
import { SettingsData } from "@/hooks/useAdminSettings";

interface SettingsTabsProps {
  settings: SettingsData;
  onSettingsChange: (newSettings: Partial<SettingsData>) => void;
}

const SettingsTabs = ({ settings, onSettingsChange }: SettingsTabsProps) => {
  return (
    <Card>
      <CardContent className="p-6">
        <Tabs defaultValue="branding" className="w-full">
          <TabsList className="grid w-full grid-cols-7 bg-muted">
            <TabsTrigger value="branding">Branding</TabsTrigger>
            <TabsTrigger value="seo">SEO</TabsTrigger>
            <TabsTrigger value="appearance">Appearance</TabsTrigger>
            <TabsTrigger value="general">General</TabsTrigger>
            <TabsTrigger value="products">Products</TabsTrigger>
            <TabsTrigger value="notifications">Notifications</TabsTrigger>
            <TabsTrigger value="system">System</TabsTrigger>
          </TabsList>
          
          <TabsContent value="branding" className="space-y-6 mt-6">
            <BrandingSettings
              settings={settings}
              onSettingsChange={onSettingsChange}
            />
          </TabsContent>

          <TabsContent value="seo" className="space-y-6 mt-6">
            <SEOSettings
              settings={settings}
              onSettingsChange={onSettingsChange}
            />
          </TabsContent>

          <TabsContent value="appearance" className="space-y-6 mt-6">
            <AppearanceSettings
              settings={settings}
              onSettingsChange={onSettingsChange}
            />
          </TabsContent>

          <TabsContent value="general" className="space-y-6 mt-6">
            <GeneralSettings
              settings={settings}
              onSettingsChange={onSettingsChange}
            />
          </TabsContent>

          <TabsContent value="products" className="space-y-6 mt-6">
            <ProductSettings
              settings={settings}
              onSettingsChange={onSettingsChange}
            />
          </TabsContent>

          <TabsContent value="notifications" className="space-y-6 mt-6">
            <NotificationSettings
              settings={settings}
              onSettingsChange={onSettingsChange}
            />
          </TabsContent>

          <TabsContent value="system" className="space-y-6 mt-6">
            <SystemSettings
              settings={settings}
              onSettingsChange={onSettingsChange}
            />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
};

export default SettingsTabs;
